import { createContext, Fragment, useContext, useMemo, type PropsWithChildren } from 'react';
import { ProgressStep } from './ProgressStep';

type ProgressStepsProps = PropsWithChildren<{
  value: string;
}>;

type ProgressStepsContext = {
  value: string;
  values: Array<string>
}

const ProgressStepsContext = createContext<ProgressStepsContext>( {
  value: '',
  values: []
} );

export const useProgressSteps = () => useContext( ProgressStepsContext );

export const ProgressSteps = ( { children, value }: ProgressStepsProps ) => {

  const Components = Array.isArray( children ) ? children : [ children ];
  const Items = Components.filter( c => c?.type?.displayName === ProgressStep.displayName );

  const values = useMemo( () => {
    return Items.map( i => i.props.value );
  }, [ Items ] );

  return (
    <ProgressStepsContext.Provider value={ {
      value,
      values
    } }>
      <div className={ 'flex flex-row h-5 mb-5' }>
        { Items.map( ( Item, index ) => {
          return (
            <Fragment key={ index }>
              { Item }
              <div className={ 'last:hidden w-[70px] h-px bg-[#C2BEBE20] mt-2.5 mx-4' } />
            </Fragment>
          )
        } )}
      </div>
    </ProgressStepsContext.Provider>
  )
}
ProgressSteps.displayName = 'ProgressSteps';
